import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../../components/Sparklines';

export const COLUMNS = (t) => [
    {
        label: t('search.keyword_clusters_detail.urls.URL'),
        key: 'url',
        data: 'url',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong>
                    <a
                        href={`/domains/${
                            window.info.id
                        }/gsc-reports/urls/url/?url=${encodeURIComponent(data)}`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data}
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.ClusterKeywords'),
        key: 'clusterKeywords',
        data: 'clusterKeywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.MaxClicks'),
        key: 'maxClicks',
        data: 'maxClicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.RankingWeeks'),
        key: 'weeks',
        data: 'weeks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.Clicks'),
        key: 'avgClicks',
        data: 'avgClicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.Trend'),
        key: 'sparkline',
        data: 'sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            return (
                <Sparkline
                    dataL={item.clicksPerDay}
                    labels={item.datesList?.map((x) => x.value)}
                    keyName={t('search.keyword_clusters_detail.urls.Clicks')}
                />
            );
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.Impressions'),
        key: 'maxImpressions',
        data: 'maxImpressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.AvgPosition'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.urls.CTR'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const value = item.avgClicks / item.maxImpressions;
            if (csvDownload) return value;

            return <strong>{numeral(value).format('0.0a')}</strong>;
        },
    },
];
